export default __webpack_public_path__ + "static/media/error_outline_24px.818cde21.svg";